var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { AwsUi } from '../../../core/runtime/src';
import logger from '../../../core/utils/src/logger';
import { ButtonDropdown } from '../../button/src/button-dropdown';
import { Item as BreadcrumbItem } from './breadcrumb-item';
import { breadcrumbItemClickHandler } from './breadcrumb-item-click-handler';
import { Icon } from '../../icon/src';
var DropdownTrigger = function (_a) {
    var isDisabled = _a.isDisabled, clickHandler = _a.clickHandler, isOpen = _a.isOpen;
    var attributes = {
        disabled: isDisabled || undefined,
        onclick: clickHandler,
        'aria-expanded': isOpen ? 'true' : undefined,
        'aria-haspopup': 'true'
    };
    return (AwsUi.__createElement("button", __assign({ className: "awsui-breadcrumb-dropdown-trigger" }, attributes), "..."));
};
var EllipsisDropdown = function (_a) {
    var dropdownItems = _a.dropdownItems, onDropdownItemClick = _a.onDropdownItemClick;
    return (AwsUi.__createElement("li", { className: "awsui-breadcrumb-ellipsis", "aria-label": "Show path" },
        AwsUi.__createElement(ButtonDropdown, { items: dropdownItems, itemClick: onDropdownItemClick, __customTrigger: DropdownTrigger }),
        AwsUi.__createElement(Icon, { name: "angle-right", variant: "disabled" })));
};
export var BreadcrumbGroup = AwsUi.__addComponent('awsui-breadcrumb-group', {
    releaseStatus: 'stable',
    callbacks: {
        initialized: function () {
            var _this = this;
            this.__onDropdownItemClick = function (ev) {
                var _a = ev.detail, id = _a.id, event = _a.event;
                var item = _this.items.find(function (item) { return item.href === id; });
                breadcrumbItemClickHandler(_this, item, event);
            };
        }
    },
    properties: {
        // An array of breadcrumb items that describes the link hierarchy for this navigation.
        // Each option has the following properties:
        //
        // * `text` [string]: The title text of the breadcrumb item
        // * `href` [string]: URL for the link within the breadcrumb item.
        //                    You should specify the link even if you have the click handler for a breadcrumb item.
        //                    This will ensure that valid markup is generated.
        //
        // Please also note that the last breadcrumb item is automatically considered the current item and will
        // be attributed with the proper `aria-current` value and rendered as inactive.
        items: {
            type: 'array',
            itemTypes: ['BreadcrumbGroup.Item']
        },
        // Provides an aria-label to the breadcrumb group that can be read by screen-readers.
        label: {
            type: 'string'
        }
    },
    regions: {
        // Region containing all the breadcrumb items in the group.
        // Use only `awsui-breadcrumb-item` components inside this region.
        //
        // **Deprecated:** Please use the `items` property instead.
        content: {
            isDefault: true
        }
    },
    events: {
        // Fired when the user clicks on a breadcrumb item.
        //
        // **AngularJS:** `ng-click` works incorrectly, you need to use `click` attribute
        click: {
            bubbles: true,
            cancelable: true,
            detailType: 'BreadcrumbGroup.ClickDetail'
        },
        // Fired when the user clicks on a breadcrumb item with the left mouse button and
        // without modifier keys pressed (CTRL, ALT, SHIFT, META).
        follow: {
            bubbles: true,
            cancelable: true,
            detailType: 'BreadcrumbGroup.ClickDetail'
        }
    },
    render: function (m, h) {
        var _this = this;
        if (!this.items || !this.items.length) {
            if (this.content) {
                logger.warnOnce('DEPRECATION WARNING: The `content` region for the awsui-breadcrumb-group ' +
                    'component is deprecated. Please use the `items` attribute instead.');
            }
            // Render the deprecated content region
            return h.region('content', 'nav', {
                class: 'awsui-breadcrumb-group',
                'aria-label': this.label
            });
        }
        var navAttributes = {
            className: 'awsui-breadcrumb-group awsui-breadcrumb-group-no-region',
            'aria-label': this.label || undefined
        };
        var breadcrumbItems = this.items.map(function (item, index) {
            var breadcrumbItemProps = {
                text: item.text,
                href: item.href || '#',
                onClick: function (event) { return breadcrumbItemClickHandler(_this, item, event); }
            };
            // We currently assume that the last breadcrumb item is always the active one
            if (index === _this.items.length - 1) {
                // Active breadcrumb item is implemented according to WAI-ARIA 1.1
                breadcrumbItemProps.ariaCurrent = 'page';
                breadcrumbItemProps.disableInteraction = true;
                breadcrumbItemProps.hideIcon = true;
            }
            return (AwsUi.__createElement("li", { className: "awsui-breadcrumb-item" },
                AwsUi.__createElement(BreadcrumbItem, __assign({}, breadcrumbItemProps))));
        });
        // Add ellipsis
        if (breadcrumbItems.length >= 3) {
            var dropdownItems = this.items
                .slice(1, this.items.length - 1)
                .map(function (item) { return ({
                id: item.href,
                text: item.text,
                href: item.href
            }); });
            breadcrumbItems = __spreadArrays([
                breadcrumbItems[0],
                AwsUi.__createElement(EllipsisDropdown, { dropdownItems: dropdownItems, onDropdownItemClick: this.__onDropdownItemClick })
            ], breadcrumbItems.slice(1));
        }
        return (AwsUi.__createElement("nav", __assign({}, navAttributes),
            AwsUi.__createElement("ol", null, breadcrumbItems)));
    }
});
//# sourceMappingURL=breadcrumb-group.js.map